import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/4d4c9785662fb0ca1091ad7e411df6df.jpeg',
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/6258dd109f796cdc9c517c75d434ad15.jpeg',
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/88664496b6458af8f212277aeef695c3.jpeg',
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/37cd735a48a160b570e68b70cc4bd62c.jpeg',
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/05d15840c2230b3f39f644627506a260.jpeg',
    'https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/d3c4d86af5e74abed3ced9bb8297de94.jpeg'
  ];

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Gallery
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Take a visual tour of our beautiful guest house
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="relative h-64 w-full overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer group"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image}
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                <i className="ri-zoom-in-line text-white text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-8 h-8 flex items-center justify-center"></i>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line w-10 h-10 flex items-center justify-center"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
